import { render, staticRenderFns } from "./IssueRoutedEntity.vue?vue&type=template&id=10b0767f&"
import script from "./IssueRoutedEntity.vue?vue&type=script&lang=js&"
export * from "./IssueRoutedEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b0767f')) {
      api.createRecord('10b0767f', component.options)
    } else {
      api.reload('10b0767f', component.options)
    }
    module.hot.accept("./IssueRoutedEntity.vue?vue&type=template&id=10b0767f&", function () {
      api.rerender('10b0767f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Issues/Components/IssueRoutedEntity.vue"
export default component.exports